module.exports = __webpack_public_path__ + "static/media/LogosStudyNSW.14ef6882.png";